// const apilink = "https://staging-cmh-back.azurewebsites.net/";
// const apilink = "http://localhost:8000/";
// const apilink = "https://cmh-back.azurewebsites.net";
// const apilink = "https://cmh-back-prod.azurewebsites.net/";
const apilink = "https://cmh-back-prod-2-hzfvg7beeya9a5cj.centralus-01.azurewebsites.net/";

export default apilink;